import { type FunctionComponent, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import Modal, { type ModalProps } from "nvent-web/components/Modal";

import style from "./TeamAccessModal.module.scss";
import { FormattedHTMLMessage } from "~/nvent-web/components/FormattedHTMLMessage/FormattedHTMLMessage";

export interface TeamAccessModalProps extends Omit<
  ModalProps,
  "center" | "children"
> {
  children?: ReactNode;
  messages: {
    info: string;
    contact: string;
  };
}

export const TeamAccessModal: FunctionComponent<TeamAccessModalProps> = (
  props
) => (
  <Modal center {...props}>
    <div className={style.content}>
      <p className={style.info}>
        <FormattedHTMLMessage id={props.messages.info} />
      </p>
      <p className={style.contact}>
        <FormattedMessage id={props.messages.contact} />
      </p>
    </div>
  </Modal>
);
